import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import * as i0 from "@angular/core";
export class CustomPdfReportSavedAssetOptionsModule {
}
CustomPdfReportSavedAssetOptionsModule.ɵfac = function CustomPdfReportSavedAssetOptionsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPdfReportSavedAssetOptionsModule)(); };
CustomPdfReportSavedAssetOptionsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CustomPdfReportSavedAssetOptionsModule });
CustomPdfReportSavedAssetOptionsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, HelpModalModule, SingleSelectDropdownModule, DisabledModule] });
